import { Component, OnInit } from '@angular/core';
import { ErrorStateService } from '../../_services/error-state/error-state.service';

/**
 * Component that triggers a 404 error state for unmatched routes.
 * Used as a wildcard route handler instead of redirecting to error pages.
 */
@Component({
  selector: 'app-wildcard-error',
  standalone: true,
  template: '', // Empty template - error display is handled by layout component
})
export class WildcardErrorComponent implements OnInit {
  constructor(private errorStateService: ErrorStateService) {}

  ngOnInit(): void {
    // Set 404 error state for unmatched routes
    this.errorStateService.setError(
      404,
      'Not Found',
      { message: 'The page you requested could not be found.' },
      window.location.pathname
    );
  }
}
